"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logout = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const auth_1 = require("../logic/auth");
const Logout = () => {
    (0, auth_1.logout)();
    return react_1.default.createElement(react_router_dom_1.Redirect, { to: '/login' });
};
exports.Logout = Logout;
//# sourceMappingURL=Logout.js.map